import { render, staticRenderFns } from "./plugin-update-logs.vue?vue&type=template&id=125a700f&scoped=true&"
import script from "./plugin-update-logs.vue?vue&type=script&lang=js&"
export * from "./plugin-update-logs.vue?vue&type=script&lang=js&"
import style0 from "./plugin-update-logs.vue?vue&type=style&index=0&id=125a700f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a700f",
  null
  
)

export default component.exports